import type { PayPeriod } from '@/api/types'

const WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/**
 * "2026-11-10T23:59:00" (Pacific, no offset) -> "Tue 10 Nov, 11:59 PM".
 *
 * Read as parts, never through Date(): the value is already Pacific wall-clock
 * time, and Date() would shift it by the viewer's own offset.
 */
export function fmtPacific(iso: string): string {
  const [d, t = '00:00'] = iso.split('T')
  const [y, m, day] = d.split('-').map(Number)
  const [hh, mm] = t.split(':').map(Number)
  const wd = WD[new Date(y, m - 1, day).getDay()]
  const h12 = hh % 12 === 0 ? 12 : hh % 12
  return `${wd} ${day} ${MON[m - 1]}, ${h12}:${String(mm).padStart(2, '0')} ${hh < 12 ? 'AM' : 'PM'}`
}

/** A UTC instant from the API ("...Z" or no zone) in the viewer's own time. */
export function fmtUtcLocal(iso: string): string {
  const d = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`)
  return d.toLocaleString(undefined, {
    weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit',
  })
}

/** One sentence on where a pay week stands with the supervisor cutoff. */
export function cutoffLine(p: PayPeriod): string {
  if (!p.closes_at) return ''
  if (p.reopened_until_utc) {
    return `The office has reopened it for supervisor changes until ${fmtUtcLocal(p.reopened_until_utc)}.`
  }
  if (p.closed_to_supervisors) {
    return `Closed to supervisor changes since ${fmtPacific(p.closes_at)} (Pacific) — ask the office.`
  }
  return `Supervisor changes close ${fmtPacific(p.closes_at)} (Pacific).`
}
